import React from 'react';
import { Link } from 'react-router-dom';
import './HomePage.css';
import placeholderImage from '../assets/placeholder.webp';
import Hero from '../components/Hero';

const HomePage: React.FC = () => {
  return (
    <div className="homepage">
      <Hero
        title="Where Flavor Meets Fun! Burbank's Bites & Billiards"
        image={placeholderImage}
        height="60vh"
        showScrollIndicator={true}
        useClipPath={true}
      />

      <main className="page-content">
        <section className="welcome-section text-center">
          <div className="container">
            <h1>Welcome to Burbank's Bites & Billiards</h1>
            <p>
              Looking for the perfect spot to unwind, grab a bite, and let loose? You've just found your new favorite hangout in San Jose. At Burbank's Bites & Billiards, we blend the energy of a bar and grill with the warmth of your neighborhood spot — creating a space where everyone feels like family.
            </p>
            <ul>
              <li>🎤 Sing your heart out with karaoke Wednesday, Friday and Sunday at 9pm.</li>
              <li>🎱 Rack 'em up on our two full-size pool tables — challenge your friends or meet someone new.</li>
              <li>🌙 Late-night cravings? We serve our full menu until midnight — a rare find in San Jose!</li>
              <li>🍔 Crave-worthy bites and cocktails that hit the spot — from classic American comfort food to creative twists you'll only find here.</li>
            </ul>
            <p>
              Backed by over 50 years of combined experience, our founding team is proud to serve the Bay Area with a passion for great food, great times, and unforgettable memories.
            </p>
            <p>
              So come through, bring your crew, and experience a vibe unique to the Burbanks neighborhood.
              Let's eat. Let's play. Let's party.
            </p>
            <p>
              Welcome to Burbank's Bites and Billiards — San Jose's go-to destination for great food, cold drinks, and non-stop fun. Whether you're craving juicy burgers, crave-worthy wings, or an ice-cold beer, we've got something for every taste. Catch the game on our big screens, shoot a round of pool, or just kick back with friends in our lively sports bar atmosphere. Check out our menu to see what's cooking and plan your next night out in the heart of San Jose.
            </p>
            <Link to="/our-story" className="story-button">Our Story »</Link>
          </div>
        </section>

        <section className="featured-items-section">
          <div className="container">
            <div className="featured-items-grid">
              <div className="featured-item text-center">
                <h2>Juicy Smash Burger</h2>
                <p>
                  Craving one of San Jose's best burgers? Meet our Juicy Smash Burger — a neighborhood favorite here at Burbank's Bites and Billiards. Made with a perfectly seasoned beef patty smashed to sizzling perfection, topped with melted cheese, crisp lettuce, fresh tomato, and our house sauce, all stacked on a toasted bun. Served with a generous side of golden, crispy fries, it's the kind of burger that keeps locals coming back. Stop by and see why it's one of our most talked-about bites in San Jose.
                </p>
              </div>
              <div className="featured-item text-center">
                <h2>Cheesy, Oven-Baked Pasta</h2>
                <p>
                  Dig into comfort food done right with our cheesy, oven-baked pasta — a local favorite here at Burbank's Bites and Billiards in San Jose. Loaded with layers of perfectly cooked pasta, savory marinara, melted mozzarella, and seasoned meat or veggies, this hearty dish hits the spot every time. It's the kind of baked pasta you crave when you want something warm, filling, and full of flavor. Swing by and see why it's one of the top picks on our San Jose menu!
                </p>
              </div>
            </div>
          </div>
        </section>
      </main>
    </div>
  );
};

export default HomePage; 